var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.5a8.5 8.5 0 01-11.555 7.934c-.174-.066-.26-.1-.33-.116a.901.901 0 00-.186-.024 2.314 2.314 0 00-.303.021l-5.12.53c-.49.05-.733.075-.877-.013a.5.5 0 01-.234-.35c-.026-.166.09-.382.324-.814l1.636-3.027c.134-.25.202-.374.232-.494a.899.899 0 00.028-.326c-.01-.123-.064-.283-.172-.604A8.5 8.5 0 1120 9.5z",
    stroke: "#1780EA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgComment;